module.exports = __webpack_public_path__ + "static/media/2.865c648e.png";